'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withContext = require('recompose/withContext');

var _withContext2 = _interopRequireDefault(_withContext);

var _awaitEmitter = require('await-emitter');

var _awaitEmitter2 = _interopRequireDefault(_awaitEmitter);

var _codevApi = require('../../utils/codev-api');

var server = _interopRequireWildcard(_codevApi);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emitter = new _awaitEmitter2.default();

var object = _propTypes2.default.object;

var enhancer = (0, _withContext2.default)({
  emitter: object,
  server: object
}, function () {
  return {
    emitter: emitter,
    server: server
  };
});

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'provideCoactContext');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/enhancers/provideCoactContext.js
// module id = 1044
// module chunks = 0